import { MAX_AGENT_IMAGE_BYTES } from '#types';

import type { ImageFileAttachment, TabularFileAttachment } from '../providers/AIContext';
import { userTempInventoryState } from './userTempInventoryState';
import { uploadTempAttachment } from './uploadTempAttachment';

interface UploadInput {
  content: Uint8Array;
  filename: string;
  contentType: string;
  sizeBytes: number;
}

export async function uploadToUserTempInventory(
  input: UploadInput,
): Promise<TabularFileAttachment | ImageFileAttachment> {
  const userId = userTempInventoryState.userId;
  if (!userId) throw new Error('userTempInventory: not connected');
  const isImage = input.contentType.startsWith('image/');
  if (isImage && input.sizeBytes > MAX_AGENT_IMAGE_BYTES) {
    throw new Error(
      `Image "${input.filename}" is ${(input.sizeBytes / 1024 / 1024).toFixed(1)} MB; max is ${MAX_AGENT_IMAGE_BYTES / 1024 / 1024} MB.`,
    );
  }
  const { fileId, fileFolder, originalPath } = await uploadTempAttachment({
    content: input.content,
    filename: input.filename,
    contentType: input.contentType,
    userId,
  });
  const kind = isImage ? 'image' as const : 'tabular' as const;
  const att: TabularFileAttachment | ImageFileAttachment = {
    kind,
    filename: input.filename,
    fileId,
    fileFolder,
    originalPath,
    contentType: input.contentType,
    sizeBytes: input.sizeBytes,
  };
  const exists = userTempInventoryState.files.some((f) => f.fileFolder === fileFolder);
  if (!exists) {
    userTempInventoryState.files = [att, ...userTempInventoryState.files];
  }
  return att;
}
